import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import GeneratePromoItems from "../../components/commons/promo/GeneratePromoItems";

function PromoModal({ show, toggle, type, action, data, register, id, isLoading = false, error }) {

    const title = type === "add" ? "Generate Pemenang" : data.name

    return (
        <>
            <Modal
                isOpen={show}
                toggle={isLoading ? undefined : toggle}
                backdrop={isLoading ? "static" : true}
                keyboard={!isLoading}
                modalTransition={{ timeout: 700 }}
                backdropTransition={{ timeout: 1300 }}
            >
                <ModalHeader className="text-extra-bold pt-5">
                    {title}
                    {!isLoading && <span className="close clickable click-in-right" onClick={toggle}>&times;</span>}
                </ModalHeader>

                <ModalBody>
                    <GeneratePromoItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                        match={id}
                        isLoading={isLoading}
                        error={error}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default PromoModal
